module.exports = __webpack_public_path__ + "static/img/6.68890f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/6.png
// module id = AM0c
// module chunks = 0